import styled from "styled-components";

export const Svg = styled.svg`
  width: 5vw;
  height: 5vw;
  margin: 0 6px;

  transition:
    transform .25s ease-out,
    fill 1s,
    filter 1s;

  will-change: transform;

  &.glow {
    filter:
        drop-shadow(0 0 6px ${({glowColor}) => glowColor})
        drop-shadow(0 0 10px ${({glowColor}) => glowColor})
  }
`;

export const Row = styled.div`
  position: relative;
  top: -50%;
  width: 100%;
  display: flex;
  padding: 10px 0;
  white-space: nowrap;
  font-size: 64px;
  transform: rotate(-30deg) translateX(-10%);
  margin: 10px 0;

  div {
    display: flex;
    animation: animate1 80s linear infinite;
    animation-delay: -80s;
  }

  div:nth-child(2) {
    animation: animate2 80s linear infinite;
    animation-delay: -40s;
  }

  &:nth-child(even) div {
    animation: animate3 80s linear infinite;
      animation-delay: -80s;
  }

  &:nth-child(even) div:nth-child(2) {
    animation: animate4 80s linear infinite;
      animation-delay: -40s;
  }

  @keyframes animate1 {
    0% { transform: translateX(100%); }
    100% { transform: translateX(-100%); }
  }

  @keyframes animate2 {
    0% { transform: translateX(0); }
    100% { transform: translateX(-200%); }
  }

  @keyframes animate3 {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(100%); }
  }

  @keyframes animate4 {
    0% { transform: translateX(-200%); }
    100% { transform: translateX(0); }
  }
`;

export const Section = styled.section`
    position: fixed;
    top: 0;
    width: 100%;
    height: 100vh;
    background: #111;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    z-index: -1;
    
    /* overlay */
    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.5);
        pointer-events: none;
        z-index: 1;
    }
`;